export default "__VITE_ASSET__C3s8uj3c__"